/**
 * This util exports two functions that ease the wishlist manipulation.
 * toApplicationSchema - transforms the wishlist core schema into the application schema
 * which is more friendly to add and remove offers from it.
 * toCoreSchema - transforms the the wishlist application schema into the core schema in order
 * to do the API request and persist the wishlist.
 */

export const toApplicationSchema = wishlist => {
  if (!wishlist || !wishlist.cities) {
    return {};
  }

  const {
    cities: { items }
  } = wishlist;

  return items.reduce(
    (acc, { city_slug, accommodation_offer_ids }) => ({ ...acc, [city_slug]: accommodation_offer_ids }),
    {}
  );
};

export const toCoreSchema = (wishlist = {}) => ({
  cities: {
    items: Object.entries(wishlist).map(([city, offerIds]) => ({ city_slug: city, accommodation_offer_ids: offerIds }))
  }
});
